<template>
  <div id="surgery" class="section p-0 dark mb-0" :style="getBackground">
    <div class="container">
      <div
        class="row justify-content-between mb-4"
        style="padding: 100px 0 160px;"
      >
        <div class="col-lg-5 col-md-6 offset-lg-1 pt-3">
          <h2 class="display-4 t700 text-white topmargin-lg">
            {{ $t('surgerysystem') }}
            <!-- 체계적인
            <br />수술 시스템 -->
          </h2>
          <h3>
            {{ $t('descfollicle') }}
            <!-- 빠르고 정확한 모낭이식 -->
          </h3>
        </div>
        <div class="col-lg-5 col-md-6 mb-0 mb-md-5">
          <p class="mb-5">
            {{ $t('descfollicle2') }}
            <!-- 포헤어는 정말 수술 잘하는 사람들이 모인 세계 제일의 비절개 모발이식
            그룹입니다.<br />
            수술에 대한 높은 이해도와 숙련된 노하우를 갖춘 전문가들이 마치
            하나의 국가대표팀처럼 갖추어져 있죠. -->
          </p>
          <h3 class="mb-2 text-white">
              {{ $t('forhairsurgerysystem') }}:
              <!-- 포헤어의 수술 시스템: -->
          </h3>
          <div class="d-flex">
            <ul class="col-10 iconlist">
              <li class="my-2">
                <i class="icon-line-circle-check t300"></i>
                <span class="pl-2">
                  {{ $t('withinhour') }}
                  <!-- 1시간 이내 모낭이식 -->
                </span>
              </li>
              <li class="my-2">
                <i class="icon-line-circle-check t300"></i>
                <span class="pl-2">
                    {{ $t('onedayonesurgery') }}
                    <!-- 하루 한 분만 수술 -->
                </span>
              </li>
              <li class="my-2">
                <i class="icon-line-circle-check t300"></i>
                <span class="pl-2">
                    {{ $t('doctorcount') }}
                    <!-- 5~6명 전문 의료진 참여 -->
                </span>
              </li>
              <li class="my-2">
                <i class="icon-line-circle-check t300"></i>
                <span class="pl-2">
                  {{ $t('descpunchsize') }}
                  <!-- 1.05mm 모낭 손상 없이 채취하는 최적의 펀치 크기 -->
                </span>
              </li>
              <li class="my-2">
                <i class="icon-line-circle-check t300"></i>
                <span class="pl-2">
                    {{ $t('descslit') }}
                    <!-- 머리카락 한올 한올의 방향과 깊이, 밀도, 디자인까지 고려 -->
                </span>
              </li>
              <li class="my-2">
                <i class="icon-line-circle-check t300"></i>
                <span class="pl-2">
                  {{ $t('descdensity') }}
                  <!-- 고밀도 모발이식 (1㎠ 당 80~100모)  -->
                </span>
              </li>
              <!-- <li class="my-2">
                <i class="icon-line-circle-check t300"></i>
                <span class="pl-2">수술 후 48시간 밀착관리 </span>
              </li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="clear"></div>
    <svg
      class="svg-curve"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1463 188.03"
    >
      <path
        style="fill:#FFF;"
        d="M-.5,288.5s297-175,792-97,599,52,671,25v143H-.5Z"
        transform="translate(0 -171.47)"
      />
    </svg> -->
  </div>
</template>

<script>
export default {
  name: "Surgery",
  data() {
    return {
      bgImg: require("@/assets/images/surgery-system.png")
    };
  },
  computed: {
    getBackground() {
      return {
        "background-image":
          "linear-gradient(to right, rgba(25,102,221,0.4), rgba(25,102,221,0.75)), url(" +
          this.bgImg +
          ")",
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "min-height": "400px"
      };
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
